export const getStepComponent = (currentStep, stepComponents, PlaceholderComponent) => {
  if (!currentStep) return null;
  return stepComponents[currentStep.id] || PlaceholderComponent;
};

export const buildStepProps = ({
  data,
  currentStep,
  currentShop,
  handleStepUpdate,
  handleStepReady,
  handleRegisterSave,
  handleEmbeddedComplete,
  handleEmbeddedNavChange,
  setEmbeddedWizardRefCallback,
  PlaceholderComponent,
  StepComponent,
}) => {
  const baseProps = {
    data,
    onUpdate: handleStepUpdate,
    onReady: handleStepReady,
    onRegisterSave: handleRegisterSave,
    shopId: currentShop,
  };

  if (currentStep?.id === 'component-configuration') {
    return {
      ...baseProps,
      onComplete: handleEmbeddedComplete,
      onNavigationChange: handleEmbeddedNavChange,
      ref: setEmbeddedWizardRefCallback,
    };
  }

  if (PlaceholderComponent && StepComponent === PlaceholderComponent && currentStep) {
    return {
      ...baseProps,
      title: currentStep.title,
      description: currentStep.description,
    };
  }

  return baseProps;
};

export const getNavigationProps = ({
  isEmbeddedStep,
  embeddedNavState,
  isStepReady,
  canGoPrev,
  isLastStep,
  saving,
}) => {
  if (isEmbeddedStep) {
    return {
      canGoPrev: embeddedNavState.canGoPrev,
      canGoNext: embeddedNavState.canGoNext,
      isLastStep: false,
      loading: saving,
    };
  }

  return {
    canGoPrev,
    canGoNext: isStepReady,
    isLastStep,
    loading: saving,
  };
};
